import * as actions from './actions.js';
import * as api from './api.js';
import * as sagas from './sagas.js';
import * as mixed from './mixed.js';

const UPCOMING_WEBINARS = 'UPCOMING_WEBINARS';
const CURRENT_WEBINARS = 'CURRENT_WEBINARS';
const PREVIOUS_WEBINARS = 'PREVIOUS_WEBINARS';
const RECORDED_WEBINARS = 'RECORDED_WEBINARS';
const LIVE_WEBINARS = 'LIVE_WEBINARS';
const MODAL_TYPE_QUIZ = 'MODAL_TYPE_QUIZ';
const MODAL_TYPE_NAVBAR = 'MODAL_TYPE_NAVBAR';
const MODAL_TYPE_DASHBOARD = 'MODAL_TYPE_DASHBOARD';
const MODAL_TYPE_DELETE_CONFIRMATION = 'MODAL_TYPE_DELETE_CONFIRMATION';

const indexConstants = {
  UPCOMING_WEBINARS,
  CURRENT_WEBINARS,
  LIVE_WEBINARS,
  RECORDED_WEBINARS,
  PREVIOUS_WEBINARS,
  MODAL_TYPE_QUIZ,
  MODAL_TYPE_NAVBAR,
  MODAL_TYPE_DASHBOARD,
  MODAL_TYPE_DELETE_CONFIRMATION
}

const globalConstants = {
  ...indexConstants,
  ...actions,
  ...api,
  ...sagas,
  ...mixed
}
export default globalConstants;



/** WEBPACK FOOTER **
 ** ./src/constants/index.js
 **/